interface IProps {
    children: React.ReactNode
}

const SideNavMenu = ({ children }: IProps) => {
    return (
        <div className='sidenav'>
            {children}
        </div>
    )
}

export default SideNavMenu